import React from 'react';
import { Server, Shield, Clock, Users, CheckCircle, Star } from 'lucide-react';
import ServicePage from './ServicePage';
import SEOHead from '../../components/SEOHead';

const managedITData = {
  title: "Managed IT Services",
  description: "Transform your IT infrastructure with our comprehensive managed services. We handle everything from day-to-day operations to strategic planning.",
  features: [
    {
      icon: Server,
      title: "24/7 Infrastructure Monitoring",
      description: "Round-the-clock monitoring and management of your entire IT infrastructure",
      details: [
        "Real-time system monitoring and alerting",
        "Proactive issue detection and resolution",
        "Performance tracking and optimization",
        "Automated maintenance and updates"
      ]
    },
    {
      icon: Shield,
      title: "Comprehensive Security",
      description: "Multi-layered security approach to protect your business",
      details: [
        "Advanced threat protection",
        "Endpoint security management",
        "Regular security audits",
        "Security awareness training"
      ]
    },
    {
      icon: Clock,
      title: "Help Desk Support",
      description: "Responsive technical support whenever you need it",
      details: [
        "24/7 technical support",
        "Multiple support channels",
        "Rapid response times",
        "Dedicated support team"
      ]
    }
  ],
  stats: [
    {
      icon: Server,
      value: "99.9%",
      label: "Uptime Guarantee"
    },
    {
      icon: Clock,
      value: "15min",
      label: "Response Time"
    },
    {
      icon: Shield,
      value: "24/7",
      label: "Monitoring"
    },
    {
      icon: Users,
      value: "500+",
      label: "Happy Clients"
    }
  ],
  process: [
    {
      number: 1,
      title: "Assessment",
      description: "Comprehensive evaluation of your current IT infrastructure"
    },
    {
      number: 2,
      title: "Planning",
      description: "Developing a tailored IT management strategy"
    },
    {
      number: 3,
      title: "Implementation",
      description: "Seamless deployment of managed services"
    },
    {
      number: 4,
      title: "Optimization",
      description: "Continuous improvement and adaptation"
    }
  ],
  pricing: [
    {
      title: "Essential",
      price: "$999/mo",
      description: "Perfect for small businesses",
      features: [
        "24/7 Monitoring",
        "Basic Security Suite",
        "Help Desk Support",
        "System Updates"
      ]
    },
    {
      title: "Professional",
      price: "$1,999/mo",
      description: "Ideal for growing businesses",
      features: [
        "Everything in Essential",
        "Advanced Security",
        "Priority Support",
        "Quarterly Reviews",
        "Disaster Recovery"
      ],
      recommended: true
    },
    {
      title: "Enterprise",
      price: "Custom",
      description: "For large organizations",
      features: [
        "Everything in Professional",
        "Dedicated Support Team",
        "Custom Solutions",
        "Executive Reporting",
        "Strategic Planning"
      ]
    }
  ],
  testimonials: [
    {
      quote: "UCX's managed IT services have transformed our operations. Their proactive approach has virtually eliminated our downtime.",
      author: "Michael Chen",
      role: "CTO",
      company: "TechFlow Solutions"
    },
    {
      quote: "The level of service and expertise we receive is outstanding. They're not just a provider, they're a true partner.",
      author: "Sarah Johnson",
      role: "Operations Director",
      company: "Global Innovations"
    },
    {
      quote: "Switching to UCX was the best decision we made. Our IT infrastructure has never been more reliable.",
      author: "David Martinez",
      role: "IT Manager",
      company: "Premier Manufacturing"
    }
  ]
};

export default function ManagedIT() {
  return (
    <>
      <SEOHead 
        title="Managed IT Services Texas | UCX MSP | 24/7 IT Support Dallas Fort Worth Austin Houston"
        description="UCX provides comprehensive managed IT services across Texas. 24/7 monitoring, help desk support, cloud solutions, and network management for businesses in Dallas, Fort Worth, Austin, Houston. Call 844-219-3935."
        keywords="managed IT services Texas, Dallas managed IT, Fort Worth MSP, Austin IT services, Houston managed service provider, 24/7 IT support Texas, cloud services Dallas, network monitoring Texas"
        canonical="https://ucx.co/services/managed-it"
      />
      <ServicePage {...managedITData} />
    </>
  );
}